import { MenuItem, Select, makeStyles } from '@material-ui/core';

import { DefaultCommandProps } from './index';

export interface MultiSelectProps extends DefaultCommandProps {
  options: string[];
}

const useStyles = makeStyles(() => ({
  input: {
    width: '100%',
  },
}));

const MultiSelect = ({ value, options, onChange, label }: MultiSelectProps) => {
  const classes = useStyles();

  return (
    <Select
      className={classes.input}
      id={label}
      labelId={label}
      multiple
      onChange={(e) => onChange(label, e.target.value as string[])}
      value={value}
    >
      {options.map((name) => (
        <MenuItem key={name} value={name}>
          {name}
        </MenuItem>
      ))}
    </Select>
  );
};

export default MultiSelect;
